import React from 'react';
import { Button } from '@marvelapp/askhub-components';
export default function SquareButton(props) {
    return (React.createElement(Button, Object.assign({ alignItems: "center", display: "flex", isSquare: true, justifyContent: "center", kind: "transparent", px: 0, size: "s" }, props)));
}
